import TagManager from 'react-gtm-module-defer';

import { removeUndefinedKeys } from '../object';

interface EventParams {
  eventName?: string;
  category?: string;
  label?: string;
  value?: string | number;
  nonInteraction?: boolean; // avoids affecting bounce rate.
}

export function trackEvent<TEvent extends EventParams = EventParams>(
  event: TEvent
) {
  const { eventName, category, label, nonInteraction, ...eventData } = event;
  const dataLayerEvent = {
    event: eventName,
    channel: 'octopus',
    event_category: category,
    event_label: label,
    non_interaction: nonInteraction,
    ...eventData,
  };
  TagManager.dataLayer({
    dataLayer: removeUndefinedKeys(dataLayerEvent),
  });
}

export interface MetricsEventParams {
  name: string;
  category: string;
  label: string;
  value: number;
}

export const trackMetricsEvent = ({
  name,
  label,
  category,
  value,
}: MetricsEventParams) => {
  trackEvent({
    eventName: name,
    category,
    label,
    value,
    nonInteraction: true,
  });
};
